import { createGlobalStyle } from 'styled-components';


const GlobalStyle = createGlobalStyle `
    :root{
        --purple-primary: #554DDE;
        --accent-pink: #F44E77;
        --neutral-light: #F2F6FF;
        --lavender-secondary: #6A6D9E; /*Primary Font Color*/
        --dark-primary: #16194F;
        --border-colour: #CAD6F1;
        
    }
    *{
        margin: 0;
        padding: 0;
        list-style: none;
        box-sizing: border-box;
        font-family: 'Nunito', sans-serif;
        text-decoration: none;
    }

    body{
        background-color: var(--neutral-light);
        color: white;
        font-size: 1.2rem;
        width: 100vw;
        min-width: 100vw !important;
        max-width: 100vw !important;
        overflow-x: hidden;
    }

    a{
        color: inherit;
    }
    p{
        color: var(--lavender-secondary);
        line-height: 1.9rem;
    }
    .secondary-heading{
        font-size: 3rem;
        color: var(--purple-primary);
        @media screen and (max-width: 845px){
            font-size: 1.7rem;
        }
    }
    .small-heading{
        font-size: 2.5rem;
        color: var(--purple-primary);
        text-align: center;
    }
    span{
        color: var(--accent-pink);
    }

    //Utilities
    .c-para{
        text-align: center;
    }
    /* img {
        @media screen and (max-width: 845px){
            transform: scale(0.8);
        }
    } */
  
`;

export default GlobalStyle;